<template>
  <div>
    <label class="vs-input--label" v-text="label" v-if="hasLabel"></label>
    <div class="custom-file">
      <input type="file" class="custom-file-input" @change="onFileUpload" accept=".csv">
      <label class="custom-file-label" v-text="displayPlaceholder" :data-btnLabel="$t('auto_call_system_browse')"></label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImportFileInput',
  data () {
    return {
      file: null
    }
  },
  props: {
    label: {
      type: String
    },
    placeholder: {
      type: String
    },
    modelError: {
      // type: Object,
      required: false
    }
  },
  computed: {
    hasLabel () {
      return typeof this.label !== 'undefined' && this.label.length > 0
    },
    displayPlaceholder () {
      if (this.file !== null) {
        return this.file.name
      } else {
        return typeof this.placeholder !== 'undefined' && this.placeholder.length > 0 ? this.placeholder : this.$t('auto_call_system_choose_file')
      }
    }
  },
  methods: {
    onFileUpload (e) {
      this.file = e.target.files[0]
      this.$emit('input', this.file)
    }
  }
}
</script>

<style lang="scss">
.custom-file {
  position: relative;
  display: inline-block;
  width: 100%;

  margin-bottom: 0;
}

.custom-file,
.custom-file-input,
.custom-file-label {
  height: calc(1.25em + 1.4rem + 1px);
}

.custom-file-input {
  position: relative;
  z-index: 2;
  width: 100%;
  margin: 0;
  opacity: 0;
}

.custom-file-label {
  padding: .375rem .75rem;
}

.custom-file-label {
  left: 0;
  z-index: 1;
  font-weight: 400;
  background-color: #FFF;
  border: 1px solid rgba(0,0,0,.2);
  border-radius: 6px;
}

.custom-file-label,
.custom-file-label::after {
  position: absolute;
  padding: .7rem;
  color: rgba(0, 0, 0, 0.4);
  line-height: 1.4;
  top: 0;
  right: 0;
}

.custom-control-label::before,
.custom-file-label,
.custom-select {
  -webkit-transition: background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
  transition: background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
}

.custom-file-input:lang(en)~.custom-file-label::after {
  content: attr(data-btnLabel);
}

.custom-file-label::after {
  padding: .375rem .75rem;
  height: auto;
}

.custom-file-label::after {
  bottom: 0;
  z-index: 3;
  display: block;
  //height: calc(1.25em + 1.4rem);
  content: attr(data-btnLabel);
  background-color: #EDEDED;
  border-left: inherit;
  border-radius: 0 6px 6px 0;
}

.custom-file-label,
.custom-file-label::after {
  position: absolute;
  padding: .7rem;
  line-height: 1.4;
  color: rgba(0, 0, 0, 0.4);
  top: 0;
  right: 0;
}

::after,
::before {
  box-sizing: border-box;
}
</style>
